import React, { useRef, useState } from "react";
import ConfirmationDialog from "../confirmation-dialog/ConfirmationDialog";
import { useCallbackPrompt } from "~/hooks/useCallbackPrommpt";
import ShareholdersForm from "./ShareholdersForm";
import { useNavigate, useParams } from "react-router-dom";

const AddShareholder = () => {
  const { current: initialShareholderData } = useRef({
    type: "",
    name: "",
    other_name: "",
    last_name: "",
    preferred_name: "",
    legal_name: "",
    email: "",
    phone: "",
    phone_code: "",
    point_of_contact: "",
    status: "",
    nationality: "",
    date_of_birth: "",
    contact_email: "",
    tax_identification_no: "",
    local_tax_id: "",
    company_registration_no: "",
    legal_structure: "",
    incorporation_country: "",
    passport_number: "",
    country_of_issue: "",
    expiry_date: "",
    social_security_number: "",
  });
  const navigate = useNavigate();
  const { id: entityid } = useParams();
  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);
  const [regData, setRegData] = useState(initialShareholderData);

  const resetRegData = (data = {}) => {
    setRegData({
      ...initialShareholderData,
      ...data,
    });
  };

  const handleConfirmNavigation = () => {
    resetRegData();
    navigate(`/entity/${entityid}/appointments-ownership?tab=shareholders`, {
      state: { skipBlocker: true },
    });
  };

  return (
    <>
      <ConfirmationDialog
        show={showPrompt}
        onConfirm={handleConfirmNavigation}
        onCancel={cancelNavigation}
      />
      <ShareholdersForm
        setShowDialog={setShowDialog}
        regData={regData}
        setRegData={setRegData}
        resetRegData={resetRegData}
      />
    </>
  );
};

export default AddShareholder;
